export default __webpack_public_path__ + "static/media/car.9493d6c9.png";